import { MealsData } from '../index'

export default function MealsDataFunc() {
  return MealsData()
}
